import { useI18n } from 'vue-i18n';
import { StatisticsKind, StatisticsSource } from '..';

import { storeToRefs } from 'pinia';
import { useStatisticsWizardStore } from '../stores';
import { statisticsKindSecondarySourceMap } from '../utils';
import { computed, type Ref } from 'vue';

export const useSourceSelector = (kind: Ref<StatisticsKind>) => {
  const { t } = useI18n();

  const statisticsWizardStore = useStatisticsWizardStore();
  const { statisticsSourceView } = storeToRefs(statisticsWizardStore);

  const source = computed(() => statisticsKindSecondarySourceMap[kind.value]);

  const viewsByKind = computed(() => [
    { name: `${t('statistics.wizard.label.viewBtn.yield')}`, value: StatisticsSource.YIELD },
    { name: `${t(`statistics.wizard.label.viewBtn.${source.value}`)}`, value: source.value }
  ]);

  return {
    statisticsSourceView,
    viewsByKind
  };
};
